import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-2 border border-text-gray-lp-200 rounded-md" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_3 = { class: "border-r border-text-gray-lp-200" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "flex items-start text-12px text-gray-lp-600" }
const _hoisted_6 = { class: "space-y-1" }
const _hoisted_7 = { class: "font-semibold text-14px text-black-lp-300 mt-0.5" }
const _hoisted_8 = { class: "text-14px text-black-lp-300" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "flex items-start text-12px text-gray-lp-600" }
const _hoisted_11 = { class: "space-y-1" }
const _hoisted_12 = { class: "font-semibold text-14px text-black-lp-300" }
const _hoisted_13 = { class: "text-14px text-black-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_profile = _resolveComponent("icon-profile")!
  const _component_icon_location_pin = _resolveComponent("icon-location-pin")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_icon_profile, {
              class: "text-gray-lp-600 w-3 mr-3",
              style: {"margin-top":"2px"}
            }),
            _createVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('claim.detail.shipperName')) + " ", 1),
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.dataDetailClaim.sttSenderName) + ", " + _toDisplayString(_ctx.dataDetailClaim.normalizedSenderPhone), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetailClaim.sttSenderAddress), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_icon_location_pin, {
            class: "text-gray-lp-600 w-3 mr-3",
            style: {"margin-top":"2px"}
          }),
          _createVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t('claim.detail.recipientName')) + " ", 1),
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.dataDetailClaim.sttRecipientName) + ", " + _toDisplayString(_ctx.dataDetailClaim.normalizedRecipientPhone), 1),
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.dataDetailClaim.sttRecipientAddress), 1)
          ])
        ])
      ])
    ])
  ]))
}